import requests from "./api/base-api";

const ProfileService = {
  getProfile: () => requests.get(`/user/v1/get-my-profile`),
  editProfile: (body) => requests.put(`/user/v1/edit-user-profile`, body),
  getTransactionList: () =>
    requests.get("/transactionPort/v1/transactions-ports-get-all-for-user"),
  getAllPackages: (params) =>
    requests.getByParams("/package/v1/get-all-packages-user", params),
  getPackageById: (id) =>
    requests.get(`/package/v1/get-package-by-id-user/${id}`),
  getAllInvitationCodeUesrs: () =>
    requests.get("/invitationcode/v1/get-my-invitation-codes"),

  createPackage: (body) =>
    requests.post("/package/v1/create-package-user", body),

  getAllDurations: () => requests.get("/package/v1/get-all-durations"),

  likePackage: (data) => requests.patch(`/package/v1/package-like`, data),
  disLikePackage: (data) => requests.patch(`/package/v1/package-dislike`, data),

  getMyPackages: () => requests.get("/package/v1/get-my-packages"),
  getSignalsByPackageId: (id) =>
    requests.get(`/signal/v1/get-signal-user/${id}`),

  getMyBanHistory: () => requests.get("/user/v1/get-my-ban-history"),

  SubscriptionPackage: (body) =>
    requests.patch("/package/v1/subscription-time", body),

  //Retrieves the list of signals sorted by the highest number of likes.
  getTopTraders: (params) => requests.get(`/user/v1/get-top-traders`, params),

  logOut: () => requests.delete(`/signal/v1/logout`),
};

export default ProfileService;
